export const DEFAULT_SKELETON_HEIGHT = '14px';
export const CARD_WIDTH = 310;
